export const version = '2.56.1';
//# sourceMappingURL=version.js.map